// Same-tab hints only. Never broadcast personal records or trigger mutations.
const listeners = new Set();

export const notifyDataChanged = (resources) => {
  const changed = new Set(resources);
  if (!changed.size) return;
  for (const listener of listeners) listener(changed);
};

export const subscribeDataChanges = (resources, refresh) => {
  const listener = (changed) => {
    if (resources.some((resource) => changed.has(resource))) refresh();
  };
  listeners.add(listener);
  return () => listeners.delete(listener);
};

export const actionResources = (type) => ({
  calendar_event: ["calendar", "approvals"], calendar_event_update: ["calendar"],
  task: ["tasks"], task_update: ["tasks"],
  email_task_accept: ["tasks","emails","notifications"],
  reminder: ["reminders"], reminder_update: ["reminders"],
  email_draft: ["emails", "approvals"],
  email_attention_ack: ["emails"],
  collaboration_request: ["collaboration", "notifications"],
  collaboration_response: ["collaboration", "notifications"],
  memory: ["memory"], monitor: ["monitors"], monitor_update: ["monitors"],
}[type] || []);
